import { render, staticRenderFns } from "./ClientNew_Details.vue?vue&type=template&id=1a33ab8c&"
import script from "./ClientNew_Details.vue?vue&type=script&lang=js&"
export * from "./ClientNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports